"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const firestore_1 = require("@react-query-firebase/firestore");
const firestore_2 = require("firebase/firestore");
const keyFactory_1 = require("../keyFactory");
/**
 * Este método esta mal porque depende de que le pases bien la ruta de la DB. Es una mala desición, pero por cuestiones de diseño debe quedar así.
 * Queria que este desde el medical_record pero no esta el nombre del doc ni el uid hasta que no cierra la consulta,
 * @param assignationPath dirección al appointment en firestore
 */
function useAppointment(firestore, assignationPath, options, queryOptions) {
    const appointmentRef = (0, firestore_2.doc)(firestore, assignationPath);
    return (0, firestore_1.useFirestoreDocumentData)(keyFactory_1.FirestoreKeys.Appointments({
        name: "appointment",
        path: "not well defined",
    }, [assignationPath]), appointmentRef, options, queryOptions);
}
exports.default = useAppointment;
